import {applyMiddleware, compose, createStore} from 'redux';
import {createLogger} from 'redux-logger';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';

const environments = {
  production: process.env.NODE_ENV === 'production',
  browser: typeof window !== 'undefined',
  reduxLogger: process.env.REDUX_LOGGER !== 'disabled'
};

export default function configureStore(initialState) {
  const middleware = [thunk];
  let store;

  if (!environments.production && environments.browser) {
    /* eslint-disable */
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          trace: true,
          traceLimit: 25
        })
      : compose;
    /* eslint-enable */

    if (environments.reduxLogger) {
      middleware.push(
        createLogger({
          collapsed: true
        })
      );
    }

    const enhancer = composeEnhancers(applyMiddleware(...middleware));

    store = createStore(rootReducer, initialState, enhancer);
  } else {
    store = createStore(
      rootReducer,
      initialState,
      compose(applyMiddleware(...middleware), f => f)
    );
  }

  if (module.hot) {
    module.hot.accept('../reducers', () => {
      const nextReducer = require('../reducers');
      store.replaceReducer(nextReducer.default);
    });
  }

  return store;
}
